export enum APP_ENTITIES {
  AGENT = 'Agent',
  AGENCY = 'Agency',
  CARRIER = 'Carrier',
  PROSPECT = 'Prospect',
}
